module.exports = __webpack_public_path__ + "media/images/logos/large-logo-6931cba24a079deb86627d31306fe349.png";